import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    objAscSort, myAxios, arrayReducer, MyFormData, scroll
} from "src/components/common/functions";

import VendorForm from "./vendorForm";
//--------------------------------------------------------------------------------------------
export default function Detail({
    history, 
    path1, 
    path2, 
    path3,
    handleSubmit, 
    vendor, 
    setVendors, 
    updateDateTime
}){
    //-------------------------------------------------------------------------------------------
    const address = [vendor.street, vendor.city, vendor.state, vendor.postalCode, vendor.country].filter(item => item).join(", ");
    //-------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const vendorDetails = useMyStore(state => state.vendorDetails);
    const setVendorDetails = useMyStore(state => state.setVendorDetails);
    //-------------------------------------------------------------------------------------------
    const deleteUser = async (e) => {
        const vendorHashKey = e.currentTarget.id;
        if(lineItems.length){
            window.alert("this vendor has associated history. Please clear the history before deletion.");
            return;
        }
        if(window.confirm("Are you sure to delete this user?")){
            const formData = new MyFormData();
            formData.append("vendorHashKey", vendorHashKey);
            //---------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("vendor/deleteVendor.php", formData);
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------
            setVendors(res.data);
            history.replace(`/${path1}`);
            scroll(null);
        }
    }
    //-------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const lineItems = vendorDetails[vendor.vendorHashKey] ?? [];
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastLineItem = currentPage * itemsPerPage;
    const indexOfFirstLineItem = indexOfLastLineItem - itemsPerPage;
    const pageNumbers = Array.from({length: Math.ceil((lineItems.length ?? 0) / itemsPerPage)}, (_, i) => (i + 1));
    //-------------------------------------------------------------------------------------------
    useEffect(() => {
        if(path2 === "" || (updateDateTime["Vendor Details"] === vendorDetails.updatedAt && vendorDetails[vendor.vendorHashKey])) return;
        setShowLoading(true);
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("vendorHashKey", vendor.vendorHashKey);
            //---------------------------------------------------------
            setShowLoading(true);
            const resPurchases = await myAxios("vendor/readSides.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resPurchases) return;
            //---------------------------------------------------------
            setVendorDetails(
                vendor.vendorHashKey, 
                resPurchases.data
                .map(d => JSON.parse(d.data)
                .map(a => ({...a, poNumber: d.poNumber})))
                .reduce(arrayReducer, [])
                .filter(p => p.vendor === vendor.vendorHashKey).sort((a, b) => objAscSort(a, b, "description")), 
                updateDateTime["Vendor Details"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[updateDateTime, path2, vendor.vendorHashKey, setVendorDetails, vendorDetails])
    return(
    showLoading?
    <div className = "border rounded p-4 text-center h5">
        Loading...
    </div>:
    <div className = "border" style = {{borderRadius: "6px"}}>
        <div style = {{display: "flex"}}>
            <div className = "col-6">
                <table className = "table flex-grow-1 noTopBorder">
                    <tbody>
                        {address?
                        <tr>
                            <th>Address</th>
                            <td>
                                {address}
                            </td>
                        </tr>
                        :<></>}
                        {vendor.creatorEmail?
                        <tr>
                            <th>Creator</th>
                            <td>
                                <UserInfo name = {vendor.creator} email = {vendor.creatorEmail}/>
                                <span className = "ml-3">{vendor.dateCreated}</span>
                            </td>
                        </tr>
                        :<></>}
                        {vendor.updaterEmail?
                        <tr>
                            <th>Updater</th>
                            <td>
                                <UserInfo name = {vendor.updater} email = {vendor.updaterEmail}/>
                                <span className = "ml-3">{vendor.dateCreated === vendor.dateUpdated?null: vendor.dateUpdated}</span>
                            </td>
                        </tr>
                        :<></>}
                        <tr id = "venderTR">
                            <th>Order History</th>
                            <td className = "position-relative pb10">
                            {lineItems.length?
                                <table className = "table table-fixed">
                                    <thead>
                                        <tr>
                                            <th className = "text-break">Item</th>
                                            <th className = "text-break">Price</th>
                                            <th className = "text-break">Quantity</th>
                                            <th className = "text-break">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {lineItems
                                    .slice(indexOfFirstLineItem, indexOfLastLineItem)
                                    .map((c, key) => <tr key = {key}>
                                        <td className = "text-break"><Link to = {`/Purchases/${c.poNumber}`}>{c.description}</Link></td>
                                        <td className = "text-break"><Link to = {`/Purchases/${c.poNumber}`}>${c.unitPrice}</Link></td>
                                        <td className = "text-break"><Link to = {`/Purchases/${c.poNumber}`}>{c.quantity}</Link></td>
                                        <td className = "text-break"><Link to = {`/Purchases/${c.poNumber}`}>${c.lineTotal}</Link></td>
                                    </tr>)}
                                    </tbody>
                                </table>
                            :null}
                            {lineItems.length?
                            <Footer
                                pageSelectId = "orders"
                            
                                length = {lineItems.length}
                                pageNumbers = {pageNumbers}
            
                                currentPage = {currentPage}
                                setCurrentPage = {setCurrentPage}
                                itemsPerPage = {itemsPerPage}
                                setItemsPerPage = {setItemsPerPage}

                                parentId = {"venderTR"}
                            />
                            :null}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className = "col-6">
                <fieldset className = "rounded border px-4" style = {{minHeight:"90%"}}>
                    <legend className = "px-2 font-weight-bold" style = {{width:"auto"}}>Background</legend>
                    <span className = "cssNotes">{vendor.background}</span>
                </fieldset>
            </div>
        </div>
        <div className = "m-3 text-right">
            <button type = "button" className = "btn btn-primary m-3" onClick = {() => history.push(`/${path1}/${path2}/Edit`)}>Edit</button>
            <button type = "button" className = "btn btn-danger m-3" onClick = {deleteUser} id = {vendor.vendorHashKey}>Delete</button>
        </div>
        {path3 === "Edit"?
        <VendorForm
            closeIt = {() => history.push(`/${path1}/${path2}`)}
            handleSubmit = {handleSubmit}
            keyword = "Edit" 
            postUrl = "vendor/updateVendor.php"
            {...vendor}
        />
        :null}
    </div>
    )
}